/**
 * UM Reports tab entry point.
 *
 * TEMP: reuses CDI/ARC+ Reports (dashboard) UI + endpoints.
 * Replace this implementation when UM-specific reports APIs/UI are ready.
 */
import TestCharts from "../../dashboard";

const UmReports = TestCharts;

export default UmReports;
